import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgKey = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M15.25 2.5c-1.525 0-2.93.767-4.207 2.043S9 7.225 9 8.75c0 .833.23 1.633.647 2.396l-5.5 5.5a.5.5 0 0 0-.137.452l.5 2.5A.5.5 0 0 0 5 20h2.5a.5.5 0 0 0 .416-.223L9.768 17H11.5a.5.5 0 0 0 .416-.223l1.45-2.175A4.8 4.8 0 0 0 15.25 15c1.525 0 2.93-.767 4.207-2.043S21.5 10.275 21.5 8.75s-.767-2.93-2.043-4.207S16.775 2.5 15.25 2.5m0 5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgKey)
export default ForwardRef
